// Core
import React, { useState, useEffect } from 'react';
import {
  Card, Row, Col, Input, Table, Modal, Form, Select, notification
} from 'antd';
import { Link, useParams, useHistory } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { PageHeader } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

// App
import { Main, TableWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import {
  pacienteServicioCreateAction,
  pacienteServicioListAction
} from '../../../redux/clinica/pacientes/actionCreator';
import PacienteConceptosView from '../conceptos/PacienteConceptos';
import BuscadorProductosServicios from '../conceptos/BuscadorCatalogo';
import { TipoTransaccion } from './../../../config/api/enums';


const { Search } = Input;
const gridStyle = {
  width: '33%',
  textAlign: 'center',
};

const CajaView = ({ setSubmenu }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const compras = useSelector(state => state.PacienteReducer.compras);
  const catalogoFormasPago = useSelector(state => state.CatalogosReducer.formasPago);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const { id } = useParams();

  const handleServicio = async (registro) => {
    const params = {
      action: 'compra-caja',
      id: 0,
      idServicio: registro.record.id,
      idPaciente: id,
      idTipoTransaccion: TipoTransaccion.VentaMostrador,
      idRecepcionista: 0,
      idDentista: 1,
    };
    const responseApi = await dispatch(pacienteServicioCreateAction(params));
    if (responseApi) {
      let mensaje = 'Servicio agregado a la compra';
      notification.success({
        message: mensaje,
      });
      // Recargar lista de conceptos a cobrar al paciente
      dispatch(pacienteServicioListAction(id, TipoTransaccion.Todos));
    } else {
      notification.success({
        message: 'Error al procesar presupuesto',
      });
    }
  };

  const hideModal = async () => {
    form.resetFields();
    setModalVisible(false);
  };

  const handleSubmit = async values => {
    console.log('handleSubmit.values: ', values);
    notification.error({
      message: 'Cobro realizado correctamente',
    });
    hideModal();

    return
    const responseApi = await dispatch(pacienteServicioCreateAction(values));
    if (responseApi) {
      let mensaje = 'Nota de evolución registrada exitosamente';
      notification.success({
        message: mensaje,
      });
      // Recargar lista de servicios en compras
      dispatch(pacienteServicioListAction(id, 2));
      hideModal();
      setBuscadorVisible(false);
    } else {
      notification.error({
        message: 'Error al procesar historial clínico',
      });
    }
  };

  const addRecord = () => {
    return (
      <Card style={{ marginTop: '10px' }}>

        <Form layout="vertical" name="form_in_modal" onFinish={handleSubmit} form={form}>
          <Form.Item name="idFormaPago" label="Forma de pago" rules={[{ required: false }]}>
            <Select placeholder="Selecciona..." options={catalogoFormasPago} notFoundContent={'Sin registros'} />
          </Form.Item>
          <Form.Item
            name="monto"
            label="Monto recibido"
            rules={[{ required: true, message: 'Campo obligatorio' }]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            name="comentarios"
            label="Comentarios"
            rules={[{ required: false, message: 'Campo obligatorio' }]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Button size="small" htmlType="Save" type="primary">
            {isLoading ? 'Cargando...' : 'Cobrar'}
          </Button>
          <Form.Item name="id" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="idCompra" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="action" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="idPaciente" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="idRecepcionista" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="idDentista" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="idTipoTransaccion" noStyle>
            <Input hidden />
          </Form.Item>


        </Form>


      </Card>
    );
  };

  return (
    <>
      <Card>
        <PageHeader
          onBack={() => history.replace(`/admin/clinica/pacientes/expediente/${id}`)}
          title="Caja de cobro"
          subTitle="Te permite cobrar servicios o productos al paciente"
        />
        <Row gutter={24}>
          <Col md={24} lg={24} sm={24}>
            <BuscadorProductosServicios callbackAction={handleServicio} />
          </Col>
        </Row>
        <br />
        <Row gutter={24}>
          <Col lg={24} md={24} sm={24}>
            <PacienteConceptosView pacienteId={id} tipoTransaccionId={TipoTransaccion.Todos} vista='caja' />
          </Col>
        </Row>
        <Row gutter={24} justify="space-around" align="middle">
          <Col span={5}>+ SUBTOTAL GLOBAL: <strong>${compras?.totales?.total_subtotal ?? '0'}</strong></Col>
          <Col span={4}>- DESCUENTOS: <strong>${compras?.totales?.total_descuento ?? '0'}</strong></Col>
          <Col span={5}>= IMPORTE TOTAL: <strong>${compras?.totales?.total_total ?? '0'}</strong></Col>
          <Col span={5}>- TOTAL PAGOS: <strong>${compras?.totales?.total_abonos ?? '0'}</strong></Col>
          <Col span={5}>= SALDO GLOBAL: <strong>${compras?.totales?.total_saldo ?? '0'}</strong></Col>
        </Row>
      </Card>      
    </>
  );
};

export default CajaView;
